import type { EtcaRedirectParams } from './useEtcaRedirect.types';

export function parseEtcaRedirectParams(
    searchParams: URLSearchParams
): EtcaRedirectParams | null {
    const geminiReservationId = searchParams.get('geminiReservationId');

    if (!geminiReservationId) return null;

    return { geminiReservationId };
}
